export default __webpack_public_path__ + "static/media/浊度Turb探头.1d249e78.jpg";